import React from 'react';
import styled from 'styled-components';

//#region Styled Components
const StyledButton = styled.button`
  background-color: var(--button-main);
  border: 0;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
  color: white;
  font-size: 0.75rem;
  white-space: nowrap;

  &:hover,
  &:focus,
  &:active {
    background-color: var(--button-hover);
    box-shadow: var(--box-shadow);
  }
`;
//#endregion

const Button = ({ children, onClick, tabIndex }) => {
  return (
    <StyledButton onClick={onClick} tabIndex={tabIndex}>
      {children}
    </StyledButton>
  );
};

export default Button;
